import React, { useEffect, useRef } from 'react'
import landingHtml from './landing.html?raw'

// Marketing front door. The page itself is authored as a standalone HTML file
// (src/pages/landing.html) and imported raw so it stays easy to edit as a page.
// The MLB/NFL board toggle is the only interactive bit — a <script> won't run when
// injected via innerHTML, so it's re-wired here after mount. CTAs are plain <a href>
// links (?sport=mlb / ?sport=nfl) that do a full navigation into the app.
export default function Landing() {
  const ref = useRef(null)

  useEffect(() => {
    document.title = 'LINEBRKR — MLB & NFL prop research'
    const root = ref.current
    if (!root) return
    const tabM = root.querySelector('#tabMLB')
    const tabN = root.querySelector('#tabNFL')
    const rowsM = root.querySelector('#mlbRows')
    const rowsN = root.querySelector('#nflRows')
    const title = root.querySelector('#bTitle')
    const date = root.querySelector('#bDate')
    if (!tabM || !tabN || !rowsM || !rowsN) return

    const show = (mlb) => {
      rowsM.hidden = !mlb
      rowsN.hidden = mlb
      tabM.classList.toggle('on', mlb)
      tabN.classList.toggle('on', !mlb)
      tabM.setAttribute('aria-selected', String(mlb))
      tabN.setAttribute('aria-selected', String(!mlb))
      if (title) title.textContent = mlb ? 'Homer Rankings' : 'Anytime TD Rankings'
      if (date) date.textContent = mlb ? 'MLB · EXAMPLE' : 'NFL · EXAMPLE'
    }
    const onM = () => show(true)
    const onN = () => show(false)
    tabM.addEventListener('click', onM)
    tabN.addEventListener('click', onN)
    show(false)   // default the mock to NFL — it's the season, and NFL is the primary CTA
    return () => {
      tabM.removeEventListener('click', onM)
      tabN.removeEventListener('click', onN)
    }
  }, [])

  return <div ref={ref} className="lbr-landing" dangerouslySetInnerHTML={{ __html: landingHtml }} />
}
